import { useEffect, useState } from "react";
import { Button, Container, Divider, Grid, Paper, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../components/breadcrumbs";
import SectionTitle from "../../../components/sectionTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNfcSymbol } from "@fortawesome/free-brands-svg-icons";
import { faInfoCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getEconomies } from "../../../controllers/company/cashless/EconomiesController";
import EconomiesDataTable from "./economies/dataTable";

export default function Cashless()
{
    const [economies,setEconomies] = useState([]);

    const theme = useTheme();
    const history = useHistory();

    const redirect = (route) => {
        history.push(route)
    }

    useEffect(()=>{
        handleGetEconomies();
    },[]);

    const handleGetEconomies = async () => {
        const response = await getEconomies();
        if(response.success === true)
        {
            setEconomies(response.data.economies);
        }
    }


    return(
        <Container maxWidth="xl">
            <CustomBreadcrumbs crumbs={[{name:'Cashless',link:'/cashless/economies'}]} returnTo={"/"}/>
            <SectionTitle title={"Cashless"}/>
            <br/>
            <Grid container spacing={3}>
                {/**Panel inicial */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Paper elevation={4}>
                        <Grid container spacing={3}>
                            <Grid item lg={10} xl={10}>
                                <Typography variant="h4" component={'h1'} fontWeight={'bold'} gutterBottom>
                                    <FontAwesomeIcon icon={faNfcSymbol} color={theme.palette.link.main} />
                                    &nbsp;Panel de Cashless
                                </Typography>
                            </Grid>
                            <Grid item lg={2} xl={2}>
                                <Button
                                    fullWidth
                                    variant='contained'
                                    endIcon={<FontAwesomeIcon icon={faPlusCircle}/>}
                                   onClick={()=>redirect('cashless/economies/create')}
                                >
                                    <Typography variant="body1">Crear economia</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                        <Divider/>
                        {/**ESTADISTICAS AQUI */}
                        <Grid container spacing={3} mt={2} mb={2}>
                            <Grid item lg={6} xl={6}>
                                <Grid container spacing={3} alignItems={'center'}>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} display={'flex'} flexDirection={'row'} justifyContent={'center'}>
                                        <FontAwesomeIcon color={theme.palette.link.main} size='2xl' icon={faInfoCircle}/>
                                    </Grid>
                                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <Typography variant="h6" component={'h2'} fontWeight={'bold'}>
                                            Actualmente nos encontramos trabajando para mostrarte datos estadísticos sobre tus economias Cashless
                                        </Typography>
                                    </Grid>
                                    
                                </Grid>
                            </Grid>
                        </Grid>
                        
                    </Paper>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <EconomiesDataTable economies={economies}/>
                </Grid>
            </Grid>
        </Container>
    )
}